































import { defineClassComponent } from '@/hooks'
import { jointGoodsModelProvider } from '../model'
import { navigateTo } from '@/router'

export default defineClassComponent(
  () =>
    class {
      jointGoodsModel = jointGoodsModelProvider.inject()

      handleGoodsClick = (goodsId: string) => {
        navigateTo('JointGoodsIndex', {
          goodsId: goodsId,
        })
      }
    },
)
